import api from "api/api";

export const getBranches = async () => await api.get("/settings/branch");
